/// <amd-module name="Search/Code/Help/SearchHelp" />

import * as React from "react";
import { VssComponent } from "VSS/Platform/Layout";
import { ISearchHelpProps } from "Search/Shared/Base/Types";
import { ISearchFilter } from "VSS/Features/Search/SearchHelp/SearchHelp.Props";
import { publishTelemetryEvent } from "Search/Shared/Base/Telemetry";
import { CodeEntity, SearchHelpFilterActivated } from "Search/Code/Help/Constants";
import { WrappedComponent } from "VSS/Platform/Layout";

class SearchHelp extends VssComponent<ISearchHelpProps> {
    public render(): JSX.Element {
        return (
            <WrappedComponent
                dependencies={["ms.vss-code-web.search-content"]}
                wrappedType="ms.vss-code-web.search-content.search-help"
                wrappedProps={
                    {
                        searchInput: this.props.searchInput,
                        onItemActivated: this.onItemActivated
                    }
                }
            />
        );
    }

    private onItemActivated = (helpFilter: ISearchFilter): void => {
        publishTelemetryEvent(
            this.context.pageContext,
            SearchHelpFilterActivated,
            CodeEntity,
            {
                filterText: helpFilter && helpFilter.text
            });
    }
}

VssComponent.register("search.code.help", SearchHelp);